<template>
  <v-text-field
    v-model="number"
    class="input-center"
    :single-line="dense"
    :dense="dense"
    :label="dense ? '' : label"
    :hide-details="
      showMessages
        ? false
        : dense
        ? !errorMessages || errorMessages.length == 0
        : false
    "
    type="number"
    :min="min ? min : 0"
    :max="max ? max : 99999999"
    :error-messages="errorMessages"
    @blur="
      number = number >= (min ? min : 0) ? number : min ? min : 0;
      number = number <= (max ? max : 99999999) ? number : max;
      number = $numberFormatter.formatWithDotNoMoreThan(
        number,
        Number.isInteger(dot) ? dot : 2,
        true
      );
    "
    style="min-width: 150px; max-width: 150px; margin-left: auto"
  >
    <template v-slot:prepend-inner>
      <v-icon
        x-small
        @click.stop="
          number =
            Number(number) - 1 >= (min ? min : 0)
              ? Number(number) - 1
              : min
              ? min
              : 0
        "
        class="pt-2 pb-1 primary--text"
      >
        fa-minus
      </v-icon>
    </template>
    <template v-slot:append>
      <v-icon
        x-small
        @click.stop="
          number = number
            ? Number(number) + 1 <= (max ? max : 99999999)
              ? Number(number) + 1
              : max
            : 1
        "
        class="pt-2 pb-1 primary--text"
      >
        fa-plus
      </v-icon>
    </template>
    <template v-slot:append-outer> <slot name="append"></slot> </template>
  </v-text-field>
</template>

<script>
import Waves from "@/api/waves";

export default {
  name: "SortingDialogNumberInput",

  props: {
    value: [String, Number],
    label: String,
    dot: Number,
    min: Number,
    max: Number,
    dense: Boolean,
    showMessages: Boolean,
    errorMessages: Array,
    allowNegative: Boolean,
    materialId: Number,
    material: Object,
  },

  data: () => ({
    number: "",
    oldMaterial: [],
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.number = this.value;
      },
    },
    number: {
      handler() {
        var editMaterial = this.material;
        if (
          !editMaterial.lockable &&
          editMaterial.sorting_num < editMaterial.confirm_num
        ) {
          Waves.lockMaterialSorting({
            stock_id: this.$route.query.stock_id,
            wave_id: this.$route.params.id,
            material_id: editMaterial.material_id,
          }).then(
            function (response) {
              //锁定分拣的商品
              if (response.data.status.isOK()) {
                editMaterial.lockable = true;
                this.$emit("input", this.number);
                this.$emit("material", editMaterial);
              } else {
                editMaterial.sorting_num = this.material.sorting_num;
                this.number = this.material.sorting_num;
                this.$emit("input", this.number);
                this.$emit("material", editMaterial);
              }
            }.bind(this)
          );
        } else {
          this.$emit("input", this.number);
        }
      },
    },
  },
};
</script>
